import React from 'react'
import { prop } from 'ramda'

import { getFullName } from '~/utils'
import * as API from '~/constants/api'

import EditableSearchField from './EditableSearchField'

const getOptionLabel = item => {
  if (item) {
    return getFullName(item)
  }

  return ''
}

const getOptionValue = item => {
  if (item) {
    const id = prop('id', item)
    const guid = prop('guid', item)
    const firstName = prop('firstName', item)
    const lastName = prop('lastName', item)

    return { id, guid, firstName, lastName }
  }

  return null
}

function UserUpdateSearchField (props) {
  return (
    <EditableSearchField
      name="user"
      label="User"
      api={API.USER_LIST}
      getOptionValue={getOptionValue}
      getOptionLabel={getOptionLabel}
      {...props}
    />
  )
}

export default UserUpdateSearchField
